// Mirrors php/Legacy/Orders/EpmsOrderLineInfo.php's TYPE_* constants.
export const ORDER_LINE_TYPE = {
    PRODUCT: 0,
    ADDED_COST: 1,
    DISCOUNT: 2,
    DELIVERY: 3,
    TOTAL: 4,
    VAT: 5,
};
// Mirrors EpmsProduct's constants for the discount lines that are not attached
// to a product line.
export const DISCOUNT_LINE_PRODUCT_UUID = {
    VOUCHER_CODE: "332b84be-5ce6-4156-b17c-f8bdc1c4a3c9",
    ACCOUNT_BALANCE: "3861c825-d871-4c9b-8c27-a0b4d4af517f",
};
export const isServerProductOrderLine = (ol) => ol.type === ORDER_LINE_TYPE.PRODUCT && "uuid" in ol;
